import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Powerbank = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M12.666 3.53a1.669 1.669 0 0 1 1.666 1.666v6a1.668 1.668 0 0 1-1.666 1.666H2.333a1.668 1.668 0 0 1-1.667-1.666v-6a1.669 1.669 0 0 1 1.667-1.667h10.333Zm0 .666H2.333a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10.333a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-5.162 2.38 3.334 2a.334.334 0 1 1-.344.572L7.666 7.451V9.53a.333.333 0 0 1-.505.286l-3.333-2a.333.333 0 1 1 .343-.572L6.999 8.94V6.862a.333.333 0 0 1 .505-.285Zm7.828 3.953a.333.333 0 0 1-.333-.333v-4a.333.333 0 1 1 .667 0v4a.333.333 0 0 1-.334.333Z" />
    </svg>
  );
};

Powerbank.category = 'product-category';

Powerbank.displayName = 'Powerbank';
